const md5 = require('md5')

export default class Gravatar {
  static getUrl(email) {
    const hash = md5(email || 'test@test.fr')
    return `https://www.gravatar.com/avatar/${hash}?d=retro`
  }
}
